import { render, staticRenderFns } from "./component_request.vue?vue&type=template&id=5c43edea&"
import script from "./component_request.vue?vue&type=script&lang=js&"
export * from "./component_request.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports